export function authService() {
    return {
        getAccessToken: () => Promise.resolve(null),
        refreshAccessToken: () => Promise.resolve(null),
        getScopes: () => Promise.resolve([]),
        isAuthenticated: () => {
            return Promise.resolve(getAccessTokenFromLocalStorage() !== null);
        },
        signin: () => Promise.resolve(),
        logout: () => Promise.resolve(),
        login: () => Promise.resolve(),
        onUserLogged: () => Promise.resolve(),
        checkUserAuthSession: () => Promise.resolve(),
    };
}
export function getAccessTokenFromLocalStorage() {
    return null;
}
//# sourceMappingURL=index.js.map